import 'babel-polyfill';
import Vue from 'vue'
import i18n from './i18n'
import App from './App'

import dataV from '@jiaminghi/data-view'

Vue.use(dataV)
//Scss 导入
import '@/assets/style/common.scss'
//分页导入
import Paging from "@/plugin/Tools/modules/Paging";
// 核心插件
import d2Admin from '@/plugin/d2admin'
// store
import store from '@/store/index'

// 菜单和路由设置
import router from './router'
import menuHeader from '@/menu/header'
import menuAside from '@/menu/aside'
import { frameInRoutes } from '@/router/routes'

//请求和接口配置
import request from '@/plugin/axios/index'
import { url } from '@/api/url'
import { sucess, error, msgConfirm } from '@/plugin/notice'
import { delData, commitData, localDel, closePage, submitType, arrayToString, stringToArray, formSetForm, getSetListByKey, getStake, setStake, bubbleSort, listSetList, getConfigUrl, deepCopy, fileDownload,
         getExpireTime ,selectDelete,selectDeleteAll, backBillData } from '@/plugin/common/index'
import { verifyAuthority } from '@/api/auth'
//导入工具
import Tools from "@/plugin/Tools";
//日期工具
import moment from "moment";
//枚举
import Enums from "@/plugin/Enums";

import Echarts from 'echarts'

//下边这两行尤为重要，数据才能正常渲染
// import gansu from 'echarts/map/json/province/gansu.json'
// Echarts.registerMap('gansu', gansu)

//阻止消息弹出
Vue.config.productionTip = true
//版本
Vue.prototype.$app_version = process.env.VUE_APP_APP_VERSION
    //声明全局变量和方法
Vue.prototype.$url = url
Vue.prototype.$http = request
Vue.prototype.$msgSucess = sucess
Vue.prototype.$msgError = error
Vue.prototype.$msgConfirm = msgConfirm
Vue.prototype.$msgDel = delData
Vue.prototype.$msgCommit = commitData
Vue.prototype.$localDel = localDel
Vue.prototype.$closePage = closePage
Vue.prototype.$submitType = submitType
Vue.prototype.$arrayToString = arrayToString
Vue.prototype.$stringToArray = stringToArray
Vue.prototype.$formSetForm = formSetForm
Vue.prototype.$listSetList = listSetList
Vue.prototype.$setStake = setStake
Vue.prototype.$bubbleSort = bubbleSort
Vue.prototype.$getExpireTime = getExpireTime
Vue.prototype.verifyAuthority = verifyAuthority
Vue.prototype.getSetListByKey = getSetListByKey
Vue.prototype.getStake = getStake
Vue.prototype.deepCopy = deepCopy
Vue.prototype.fileDownload = fileDownload
Vue.prototype.getConfigUrl=getConfigUrl
Vue.prototype.selectDelete = selectDelete
Vue.prototype.selectDeleteAll = selectDeleteAll
Vue.prototype.$msgBack = backBillData
//工具
Vue.prototype.Tools = Tools
//日期时间工具
Vue.prototype.moment = moment
//枚举
const enums = Enums.get()
const { TableTypes } = enums.Types
Vue.prototype.TableTypes = TableTypes
Vue.prototype.ButtonEnums = enums.Buttons
Vue.prototype.Status = enums.Status
Vue.prototype.Models = enums.Models
//枚举
//分页
Vue.prototype.Paging = Paging

// 注册全局过滤器
import * as custom from '@/plugin/common/myFilter'
Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

Vue.prototype.$echarts = Echarts


// 核心插件
Vue.use(d2Admin)


new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    created() {
        // 处理路由 得到每一级的路由设置
        this.$store.commit('d2admin/page/init', frameInRoutes)
            // 设置顶栏菜单
        this.$store.commit('d2admin/menu/headerSet', menuHeader)
            // 设置侧边栏菜单
        this.$store.commit('d2admin/menu/asideSet', menuAside)
            // 初始化菜单搜索功能
        this.$store.commit('d2admin/search/init', menuHeader)
    },
    mounted() {
        // 展示系统信息
        this.$store.commit('d2admin/releases/versionShow')
            // 用户登录后从数据库加载一系列的设置
        this.$store.dispatch('d2admin/account/load')
            // 获取并记录用户 UA
        this.$store.commit('d2admin/ua/get')
            // 初始化全屏监听
        this.$store.dispatch('d2admin/fullscreen/listen')
    },
    watch: {}
}).$mount('#app')
